export default __webpack_public_path__ + "static/media/pinetrees.63944fec.png";